import { useEffect, useRef } from 'react';

import { type FilterLegacy } from '@verantos-dev/types-cohorts';

export const useSimpleEventScroll = (
  conceptFilters: FilterLegacy[],
  numericFilters: FilterLegacy[],
  relatedEntityFilters: FilterLegacy[],
  uniquenessFilters: FilterLegacy[]
) => {
  //
  // scroll to bottom of section when add filter actions
  //
  const headerRef = useRef<HTMLDivElement>(null);
  const dialogContentRef = useRef<HTMLDivElement>(null);
  const conceptFilterRef = useRef<HTMLDivElement>(null);
  const numericFilterRef = useRef<HTMLDivElement>(null);
  const relatedEntityFilterRef = useRef<HTMLDivElement>(null);
  const uniquenessFilterRef = useRef<HTMLDivElement>(null);

  const headerHeight = Math.round(headerRef?.current?.clientHeight ?? 0) + 16;

  // scroll when a concept filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;

    if (conceptFilterDiv && componentDiv) {
      if (headerHeight + conceptFilterDiv.clientHeight - componentDiv.clientHeight > 0) {
        componentDiv.scrollTo({
          left: 0,
          top: headerHeight + conceptFilterDiv.clientHeight - componentDiv.clientHeight + 16,
          behavior: 'auto',
        });
      }
    }
  }, [conceptFilters.length, headerHeight]);

  // scroll when a numeric filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;
    const numericFilterDiv = numericFilterRef.current;

    let conceptFilterHeight = 0;
    if (conceptFilterDiv) {
      conceptFilterHeight = conceptFilterDiv.clientHeight + 16;
    }

    if (numericFilterDiv && componentDiv) {
      if (
        headerHeight +
          conceptFilterHeight +
          numericFilterDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            conceptFilterHeight +
            numericFilterDiv.clientHeight -
            componentDiv.clientHeight +
            16,
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, numericFilters.length]);

  // scroll when a related entity filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;
    const numericFilterDiv = numericFilterRef.current;
    const relatedEntityFilterDiv = relatedEntityFilterRef.current;

    let conceptFilterHeight = 0;
    if (conceptFilterDiv) {
      conceptFilterHeight = conceptFilterDiv.clientHeight + 16;
    }

    let numericFilterHeight = 0;
    if (numericFilterDiv) {
      numericFilterHeight = numericFilterDiv.clientHeight + 16;
    }

    if (relatedEntityFilterDiv && componentDiv) {
      if (
        headerHeight +
          conceptFilterHeight +
          numericFilterHeight +
          relatedEntityFilterDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            conceptFilterHeight +
            numericFilterHeight +
            relatedEntityFilterDiv.clientHeight -
            (componentDiv.clientHeight + 16),
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, relatedEntityFilters.length]);

  // scroll when uniqueness filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;
    const numericFilterDiv = numericFilterRef.current;
    const relatedEntityFilterDiv = relatedEntityFilterRef.current;
    const uniquenessFilterDiv = uniquenessFilterRef.current;

    let conceptFilterHeight = 0;
    if (conceptFilterDiv) {
      conceptFilterHeight = conceptFilterDiv.clientHeight + 16;
    }

    let numericFilterHeight = 0;
    if (numericFilterDiv) {
      numericFilterHeight = numericFilterDiv.clientHeight + 16;
    }

    let relatedEntityFilterHeight = 0;
    if (relatedEntityFilterDiv) {
      relatedEntityFilterHeight = relatedEntityFilterDiv.clientHeight + 16;
    }

    if (uniquenessFilterDiv && componentDiv) {
      if (
        headerHeight +
          conceptFilterHeight +
          numericFilterHeight +
          relatedEntityFilterHeight +
          uniquenessFilterDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            conceptFilterHeight +
            numericFilterHeight +
            relatedEntityFilterHeight +
            uniquenessFilterDiv.clientHeight -
            (componentDiv.clientHeight + 16),
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, uniquenessFilters.length]);

  return {
    headerRef,
    dialogContentRef,
    conceptFilterRef,
    numericFilterRef,
    relatedEntityFilterRef,
    uniquenessFilterRef,
  };
};
